import { ApolloError } from '@apollo/client';
import { RequestStateValue } from '../../requestStates/RequestStateTypes';

/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const getDataFetchingClientRequestState = (
  error: ApolloError | undefined,
  loading: boolean,
  hasData?: boolean
): RequestStateValue => {
  if (loading) {
    return 'PENDING';
  }
  if (error) {
    return 'FAILED';
  }
  if (hasData !== undefined) {
    return hasData ? 'SUCCEEDED' : 'UNINITIALIZED';
  }
  return 'SUCCEEDED';
};
